'use client';

import { ReactNode, useRef } from 'react';
import { styled } from '@linaria/react';
import Button from '@fe-common-ui/Button';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import useFolder from '@fe-news/hooks/use-folder';
import { GTMEventKey, CustomEventName, GTMConstants } from '@fe-cnyes/fe-common-gtm';

const TagsContainer = styled.div<{ isFold?: boolean }>`
  margin: 0 24px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  max-height: ${({ isFold }) => (isFold ? '80px' : '100%')};
  overflow: hidden;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    margin: 0 16px;
  }
`;

const FolderContainer = ({ children }: { children?: ReactNode }) => {
  const tagsReference = useRef<HTMLDivElement | null>(null);
  const { isExpand, setIsExpand, order } = useFolder(tagsReference, 2);

  const onClick = () => setIsExpand(v => !v);
  return (
    <TagsContainer ref={tagsReference} isFold={!isExpand}>
      {children}
      <Button.Folder
        active={isExpand}
        onClick={onClick}
        order={order}
        hide={order === -1}
        theme='white'
        gtmEvent={{
          [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
          [GTMEventKey.SECTION]: `${GTMConstants.SECTION_PLACEHOLDER}_文章標籤`,
          [GTMEventKey.CLICK_ITEM]: isExpand ? '收起' : '更多'
        }}
      />
    </TagsContainer>
  );
};

export default FolderContainer;
